import type { ListThreadMessagesParams } from '../../fetchers/chat/chat-fetchers';

export const chatKeys = {
    all: ['chat'] as const,
    messages: (threadId: string, params?: ListThreadMessagesParams) =>
        [...chatKeys.thread(threadId), 'messages', params ?? {}] as const,
    thread: (threadId: string) => [...chatKeys.threads(), threadId] as const,
    threads: () => [...chatKeys.all, 'threads'] as const,
} as const;
